// Core
import { HTMLAttributes } from 'react';

// Types
import { SortOrder } from '../../../types/global';

export enum ColumnAlign {
  center = 'center',
  left = 'left',
  right = 'right',
}

export interface TableColumnProps {
  align?: ColumnAlign;
  className?: string;
  dataIndex: string;
  defaultSortOrder?: SortOrder;
  key: string;
  render?: (text: string, record: any, index: number) => string | JSX.Element;
  sorter?: boolean | ((a: any, b: any) => number);
  sortOrder?: SortOrder;
  title?: string | JSX.Element;
}

export interface TablePaginationProps {
  current: number;
  onPageChange: (page: number, newPageSize: number) => void;
  pageSize: number;
  totalItems: number;
}

export interface TableProps {
  className?: string;
  columns: TableColumnProps[];
  fixedHeader?: boolean;
  onChange?: (pagination: any, filters: any, sorter: any) => void;
  onClickRow?: (record: any) => HTMLAttributes<any>;
  pagination?: TablePaginationProps | false;
  rows: Record<string, any>[];
  testId?: string;
}
